<template>
  <v-autocomplete
    v-model="selectedEquipes"
    label="Equipes"
    item-text="nome"
    item-value="colaboradores"
    :items="arrayEquipes"
    :dark="dark"
    :multiple="multiple"
    :rules="validate ? [rules.required] : ''"
    @change="onChanged()"
  >
    <template v-if="multiple" v-slot:prepend-item>
      <v-btn color="blue darken-2" text depressed @click="selectAll()">Marcar Todos</v-btn>&nbsp;
      <v-btn color="blue darken-2" text depressed @click="selectAll(false)">Desmarcar Todos</v-btn>

      <v-divider class="mt-2 mb-2"></v-divider>
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index === 0">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === 1" class="red--text caption">(+{{ selectedEquipes.length - 1 }})</span>
    </template>
  </v-autocomplete>
</template>

<script>
import rules from "@/utils/rules";
import { mapGetters } from "vuex";
import { Supervisor } from "@/services/dashboard";

export default {
  name: "SelectEquipes",

  props: {
    multiple: {
      type: Boolean,
      default: false
    },

    dark: {
      type: Boolean,
      default: false
    },

    validate: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      arrayEquipes: [],
      selectedEquipes: [],
      icon: "",
      rules: rules
    };
  },

  computed: {
    ...mapGetters("auth", ["getUser"])
  },

  methods: {
    async getEquipes() {
      try {
        const equipes = await new Supervisor().selectEquipes(this.getUser.cpf);
        this.arrayEquipes = equipes;
      } catch (error) {
        this.$toast.error(error);
      }
    },

    selectAll(all = true) {
      if (all) {
        this.selectedEquipes = this.arrayEquipes.map(value => value.colaboradores);
      } else {
        this.selectedEquipes = [];
      }

      this.onChanged();
    },

    onChanged() {
      this.$emit("onChanged", this.selectedEquipes);
    }
  },

  mounted() {
    this.getEquipes();
  }
};
</script>
